import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Agent, Agents } from '@ucc/cc-common-ui';
import { NotificationAgent } from 'state/Notifications/types';

const initialState: Agents = {};

const config = createSlice({
  initialState,
  name: 'agents',
  reducers: {
    setAgent: (state, { payload }: PayloadAction<NotificationAgent>) => {
      state[payload.key] = {
        ...payload,
      };
    },
    setAgentAvatar: (state, { payload }: PayloadAction<Omit<Agent, 'firstName'>>) => {
      state[payload.key] = {
        ...state[payload.key],
        avatarUrl: payload.avatarUrl,
      };
    },
    removeAgent: (state, { payload }: PayloadAction<NotificationAgent>) => {
      delete state[payload.key];
    },
  },
});

export const { setAgent, setAgentAvatar, removeAgent } = config.actions;

export default config.reducer;
